import React from "react";

const READOUTS = [
  ["Layer", "248 / 482"],
  ["Nozzle", "215 °C"],
  ["Bed", "60 °C"],
  ["ETA", "3h 42m"],
];

/** Decorative "live print job" card shown alongside the hero. */
export default function LivePrintCard() {
  return (
    <div
      className="border border-white/10 bg-black/40 backdrop-blur-md p-6 word-in"
      style={{ animationDelay: "600ms" }}
    >
      <div className="flex items-center justify-between mb-5">
        <span className="label-overline">Live Job · #4471</span>
        <span className="flex items-center gap-2 text-[10px] font-mono text-[#10B981]">
          <span className="w-1.5 h-1.5 bg-[#10B981] rounded-full pulse-dot" />
          PRINTING
        </span>
      </div>
      <div className="font-display text-xl mb-1">Hexapod Chassis</div>
      <div className="text-xs text-zinc-500 mb-5 font-mono">
        PLA · 0.16mm · 22% gyroid
      </div>

      {/* Mini printer rail */}
      <div className="relative h-20 mb-5 border border-white/10 bg-black/40 overflow-hidden">
        <div className="absolute inset-x-3 top-4 h-[2px] bg-gradient-to-r from-white/5 via-white/25 to-white/5" />
        <div className="absolute top-2 left-3 head-move">
          <div className="w-7 h-5 bg-[#FF5722] border border-[#F4511E] shadow-lg shadow-[#FF5722]/40" />
          <div className="w-[3px] h-4 bg-[#FF5722] mx-auto" />
        </div>
        <div className="absolute inset-x-3 bottom-2 h-6 bg-white/[0.03] border border-white/10">
          <div
            className="absolute inset-x-1 top-1 h-2"
            style={{
              backgroundImage:
                "repeating-linear-gradient(90deg, rgba(255,87,34,0.5) 0 3px, transparent 3px 7px)",
            }}
          />
          <div
            className="absolute inset-x-1 bottom-1 h-1.5"
            style={{
              backgroundImage:
                "repeating-linear-gradient(90deg, rgba(255,87,34,0.3) 0 3px, transparent 3px 7px)",
            }}
          />
        </div>
      </div>

      <div className="space-y-3 font-mono text-[11px]">
        {READOUTS.map(([k, v]) => (
          <div key={k} className="flex justify-between border-b border-white/5 pb-2">
            <span className="text-zinc-500">{k}</span>
            <span className="text-white">{v}</span>
          </div>
        ))}
      </div>
      <div className="mt-6 h-1 bg-white/10 relative overflow-hidden shimmer">
        <div className="absolute inset-y-0 left-0 bg-[#FF5722]" style={{ width: "51%" }} />
      </div>
      <div className="mt-2 flex justify-between text-[10px] font-mono text-zinc-500">
        <span>51% complete</span>
        <span>Mat. used 142g</span>
      </div>
    </div>
  );
}
